import { useRef, useState, useEffect, forwardRef, useImperativeHandle } from "react";

const ReproductorMp3 = forwardRef(({ setPlay }, ref) => {
    const canciones = [
        { src: "/audio/Subnautica - Diving In Too Deep.mp3" },
        { src: "/audio/Subnautica - Deep Blue By Miracle Of Sound.mp3" },
        { src: "/audio/Keep Shelly in Athens - (Don't Fear) The Reaper.mp3" },
        { src: "/audio/Orbital - halcyon and on and on.mp3" },
        { src: "/audio/Luka Kloser - One More Time.mp3" },
        
    ];

    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const [volume, setVolume] = useState(0.5);
    const [readyToPlay, setReadyToPlay] = useState(false);

    const audioRef = useRef(null);

    // Manejar reproducción y pausa
    const togglePlay = () => {
        if (audioRef.current) {
            if (!readyToPlay) {
                setReadyToPlay(true); // Permitir reproducción tras el primer clic
            }
            if (isPlaying) {
                audioRef.current.pause();
            } else {
                audioRef.current.play().catch(err => console.error("Error al reproducir:", err));
            }
            setIsPlaying(!isPlaying);
            setPlay(!isPlaying)
        }
    };

    // Cambiar canción asegurando que `play()` no se interrumpe
    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % canciones.length);
    };

    const handlePrevious = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? canciones.length - 1 : prevIndex - 1
        );
    };

    // Cargar nueva canción cuando `currentIndex` cambia
    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.load();
        }
    }, [currentIndex]);

    // Reproducir automáticamente la canción cuando esté cargada
    const handleLoadedMetadata = () => {
        if (readyToPlay && audioRef.current) {
            audioRef.current.play().catch(err => console.error("Error al reproducir:", err));
            setIsPlaying(true);
        }
    };

    // Manejo del volumen
    const handleVolumeChange = (e) => {
        const newVolume = parseFloat(e.target.value);
        setVolume(newVolume);
        if (audioRef.current) {
            audioRef.current.volume = newVolume;
        }
    };

    // Aplicar volumen inicial cuando el componente monta
    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.volume = volume;
        }
    }, [volume]);

    // Se ejecuta desde el Head ------------
    const playDesdeMenu = () => {
        togglePlay();
    };

    useImperativeHandle(ref, () => ({
        playStop: playDesdeMenu
    }));
    // -------------------------------------

    return (
        <div className="row-audio">
            <div className="audio-embebido-container">
                <div className="left">
                    <div className="audio-player">
                        <div className="controls">
                            <button onClick={handlePrevious}>
                                <img src="/icons/previous.svg" alt="Anterior" width="24" height="24" />
                            </button>
                            <button onClick={togglePlay}>
                                <img
                                    src={isPlaying ? "/icons/pause.svg" : "/icons/play.svg"}
                                    alt={isPlaying ? "Pause" : "Play"}
                                    width="24"
                                    height="24"
                                />
                            </button>
                            <button onClick={handleNext}>
                                <img src="/icons/next.svg" alt="Siguiente" width="24" height="24" />
                            </button>
                        </div>
                        <audio
                            ref={audioRef}
                            src={canciones[currentIndex].src}
                            onEnded={handleNext}
                            onLoadedMetadata={handleLoadedMetadata}
                        />
                    </div>

                    <div className="volume-control">
                        <input
                            type="range"
                            min="0"
                            max="1"
                            step="0.01"
                            value={volume}
                            onChange={handleVolumeChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
});

export default ReproductorMp3;
